import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDevTools } from "./DevToolsProvider";

export function DevToolsDrawer() {
  const {
    plugins,
    activePluginId,
    isDrawerOpen,
    isSidebarExpanded,
    setActivePlugin,
  } = useDevTools();
  const activePlugin = plugins.find((p) => p.id === activePluginId);

  // Drawer content is gated on hasMounted to keep server HTML and client's
  // first render in sync — activePluginId comes from localStorage on the
  // client (lazy init in DevToolsProvider) but is null on the server. The
  // drawer is hidden initially (isDrawerOpen is always reset to false), so
  // deferring the children to a post-mount render has no UX impact.
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => setHasMounted(true), []);

  const drawerClass = [
    "dt-drawer",
    isDrawerOpen && isSidebarExpanded ? "dt-drawer--open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={drawerClass}>
      {hasMounted && activePlugin && (
        <>
          <div className="dt-drawer__header">
            <span className="dt-drawer__title">{activePlugin.name}</span>
            <button
              className="dt-drawer__close"
              onClick={() => setActivePlugin(null)}
              type="button"
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
          <div className="dt-drawer__content">{activePlugin.render()}</div>
        </>
      )}
    </div>
  );
}
